import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL || 'https://sawsindirapuram.com/admin/public';

const API = axios.create({
  baseURL: `${API_URL}/api`,
  headers: { 'Content-Type': 'application/json' }
});

export const UPLOADS_URL = process.env.REACT_APP_UPLOADS_URL || 'https://sawsindirapuram.com/admin/public/uploads';


export default API;
